// utils/seoRoutes.js
import React from 'react';
import ThurentHome from "./redesign/components/ThurentHome";
import SendInvitationService from "./redesign/components/Services/SendInvitationService";
import BookPriestService from "./redesign/components/Services/BookPriestService";
import RentFromTentHouse from "./redesign/components/Services/RentFromTentHouse";
import CateringService from "./redesign/components/Services/CateringService";

// Export array of Route configurations
export const seoRoutesConfig = [
  // Main service pages
  { path: '/service/hire-a-priest', element: <BookPriestService />, exact: true },
  { path: '/service/invite', element: <SendInvitationService />, exact: true },
  { path: '/service/rental-services-for-events', element: <RentFromTentHouse />, exact: true },
  { path: '/service/book-catering', element: <CateringService />, exact: true },
  
  // SEO optimized landing pages for ThurentHome (Generic event services)
  { path: '/event-organisers', element: <ThurentHome serviceType="event-organisers" /> },
  { path: '/event-planning-companies', element: <ThurentHome serviceType="event-planning-companies" /> },
  { path: '/event-planning-services', element: <ThurentHome serviceType="event-planning-companies" /> },
  { path: '/home-event-services', element: <ThurentHome serviceType="home-event-services" /> },
  { path: '/party-planners', element: <ThurentHome serviceType="party-planners" /> },
  { path: '/corporate-event-planners', element: <ThurentHome serviceType="corporate-event-planners" /> },
  { path: '/event-equipment-rental', element: <ThurentHome serviceType="event-equipment-rental" /> },
  { path: '/event-planner-website', element: <ThurentHome serviceType="event-planner-website" /> },
  { path: '/event-furniture-rental', element: <ThurentHome serviceType="event-furniture-rental" /> },
  
  // Tent House Services - USE RentFromTentHouse COMPONENT
  { path: '/tent-house-services-near-me', element: <RentFromTentHouse tentServiceType="tent-house-near-me" /> },
  { path: '/tent-house-near-me', element: <RentFromTentHouse tentServiceType="tent-house-near-me" /> },
  { path: '/tent-house-rental', element: <RentFromTentHouse tentServiceType="tent-house-rental" /> },
  { path: '/tents-on-rent', element: <RentFromTentHouse tentServiceType="tents-on-rent" /> },
  { path: '/chair-table-rentals-near-me', element: <RentFromTentHouse tentServiceType="chair-table-rentals" /> },
  
  // Catering Services - USE CateringService COMPONENT
  { path: '/home-catering-services-near-me', element: <CateringService cateringType="home-catering-near-me" /> },
  { path: '/home-catering-near-me', element: <CateringService cateringType="home-catering-near-me" /> },
  { path: '/catering-at-home-near-me', element: <CateringService cateringType="catering-at-home" /> },
  { path: '/caterers-in-india', element: <CateringService cateringType="caterers-india" /> },
  { path: '/book-catering-online', element: <CateringService cateringType="book-catering" /> },
  { path: '/local-catering-service', element: <CateringService cateringType="local-catering" /> },
  { path: '/affordable-caterer', element: <CateringService cateringType="affordable-caterer" /> },
  
  // Priest Services - USE BookPriestService COMPONENT
  { path: '/book-a-pandit-online', element: <BookPriestService priestType="pandit-online" /> },
  { path: '/hire-a-priest-for-puja', element: <BookPriestService priestType="hire-priest" /> },
  { path: '/online-puja-booking', element: <BookPriestService priestType="online-puja" /> },
  { path: '/pooja-booking-online', element: <BookPriestService priestType="pooja-booking" /> },
  { path: '/book-puja-online', element: <BookPriestService priestType="book-puja" /> },
  
  // Invitation Services - USE SendInvitationService COMPONENT
  { path: '/online-invitation-maker', element: <SendInvitationService invitationType="invitation-maker" /> },
  { path: '/create-invitation-online', element: <SendInvitationService invitationType="create-invitation" /> },
  { path: '/evite-cards', element: <SendInvitationService invitationType="evite-cards" /> },
  { path: '/card-invitation-maker', element: <SendInvitationService invitationType="card-invitation-maker" /> },
  { path: '/digital-invitation-cards', element: <SendInvitationService invitationType="digital-invitation" /> },
];

// Service type mapping for reference
export const seoRouteMapping = [
  // Event Organiser Services
  { path: 'event-organisers', serviceType: 'event-organisers' },
  { path: 'event-planning-companies', serviceType: 'event-planning-companies' },
  { path: 'event-planning-services', serviceType: 'event-planning-companies' },
  { path: 'home-event-services', serviceType: 'home-event-services' },
  { path: 'party-planners', serviceType: 'party-planners' },
  { path: 'corporate-event-planners', serviceType: 'corporate-event-planners' },
  { path: 'event-equipment-rental', serviceType: 'event-equipment-rental' },
  { path: 'event-planner-website', serviceType: 'event-planner-website' },
  { path: 'event-furniture-rental', serviceType: 'event-furniture-rental' },
  
  // Tent House Services
  { path: 'tent-house-services-near-me', serviceType: 'tent-house-near-me' },
  { path: 'tent-house-near-me', serviceType: 'tent-house-near-me' },
  { path: 'tent-house-rental', serviceType: 'tent-house-rental' },
  { path: 'tents-on-rent', serviceType: 'tents-on-rent' },
  { path: 'chair-table-rentals-near-me', serviceType: 'chair-table-rentals' },
  
  // Catering Services
  { path: 'home-catering-services-near-me', serviceType: 'home-catering-near-me' },
  { path: 'home-catering-near-me', serviceType: 'home-catering-near-me' },
  { path: 'catering-at-home-near-me', serviceType: 'catering-at-home' },
  { path: 'caterers-in-india', serviceType: 'caterers-india' },
  { path: 'book-catering-online', serviceType: 'book-catering' },
  { path: 'local-catering-service', serviceType: 'local-catering' },
  { path: 'affordable-caterer', serviceType: 'affordable-caterer' },
  
  // Priest Services
  { path: 'book-a-pandit-online', serviceType: 'pandit-online' },
  { path: 'hire-a-priest-for-puja', serviceType: 'hire-priest' },
  { path: 'online-puja-booking', serviceType: 'online-puja' },
  { path: 'pooja-booking-online', serviceType: 'pooja-booking' },
  { path: 'book-puja-online', serviceType: 'book-puja' },
  
  // Invitation Services
  { path: 'online-invitation-maker', serviceType: 'invitation-maker' },
  { path: 'create-invitation-online', serviceType: 'create-invitation' },
  { path: 'evite-cards', serviceType: 'evite-cards' },
  { path: 'card-invitation-maker', serviceType: 'card-invitation-maker' },
  { path: 'digital-invitation-cards', serviceType: 'digital-invitation' },
];

// Helper function to get query parameter version
export const getSeoQueryUrl = (path) => {
  const route = seoRouteMapping.find(r => r.path === path);
  return route ? `/?service=${route.serviceType}` : '/';
};